import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const cta = "inline-flex min-h-11 items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-bold transition-all duration-300 hover:-translate-y-0.5";
export const ctaPrimary = `${cta} bg-emerald-600 text-white hover:bg-emerald-700 shadow-[0_14px_28px_rgba(5,150,105,0.18)]`;
export const ctaSecondary = `${cta} border border-emerald-100 bg-white text-emerald-700 hover:border-emerald-300`;
export const h2Class = "font-display text-3xl font-bold leading-tight tracking-tight text-slate-800 sm:text-4xl lg:text-5xl";

export function Label({ children, light = false, testId }) {
  return <p className={`mb-4 text-xs font-extrabold uppercase tracking-[0.22em] ${light ? "text-teal-100" : "text-teal-500"}`} data-testid={testId}>{children}</p>;
}

export function HanaLogo({ compact = false }) {
  return (
    <span className={`flex items-baseline gap-1.5 ${compact ? "text-2xl" : "text-3xl"}`} data-testid="hana-logo-wrapper">
      <span className="font-extrabold tracking-normal text-slate-800" data-testid="hana-logo-text-fr">Hana</span>
      <span className="font-light text-teal-500" data-testid="hana-logo-separator">|</span>
      <span className="font-extrabold text-slate-600" style={{ fontFamily: "'Noto Sans Arabic', sans-serif" }} data-testid="hana-logo-text-ar">هناء</span>
    </span>
  );
}

export function useHashScroll() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const timer = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    return () => clearTimeout(timer);
  }, [hash]);
}

export function useSeo(title, description) {
  useEffect(() => {
    const previousTitle = document.title;
    let meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute("content") || "";
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    document.title = title;
    meta.setAttribute("content", description);
    return () => {
      document.title = previousTitle;
      meta?.setAttribute("content", previousDescription);
    };
  }, [title, description]);
}
